import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../../services/auth-service/auth.service';
import { CompanyService } from '../../../services/company-service/company.service';
import { CONSTANTS } from '../../../utilities/Constants';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormUtils } from '../../../utilities/FormUtils/FormUtils';

@Component({
  selector: 'app-create-admin-dialog',
  templateUrl: './create-admin-dialog.component.html',
  styleUrls: ['./create-admin-dialog.component.css']
})
export class CreateAdminDialogComponent implements OnInit {


  message;
  created = false;
  error;
  companies = [];
  roles = [];
  clientData: any = null;

  adminForm: FormGroup;

  constructor(private companService: CompanyService, private auth: AuthService, public dialogRef: MatDialogRef<CreateAdminDialogComponent>, @Inject(MAT_DIALOG_DATA) data) {
    this.clientData = data;
  }

  ngOnInit() {

    this.adminForm = new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.email]),
      password: new FormControl('skjhda1871!@1khj'),
      role: new FormControl('',[Validators.required]),
      clientCompanyId: new FormControl(this.clientData ? this.clientData.clientId : null)
    })
    
    // Only load companies if no client data is provided (for backward compatibility)
    if (!this.clientData) {
      this.companService.getClients().then((res) => {
        this.companies = res.data;
      })
    }
    
    this.auth.getRoles().then((res) => {
      // Show role id 1 only if logged in user is SUPER_USER, otherwise filter it out
      if (this.auth.hasOneOfRoles([CONSTANTS.ADMIN_TYPE_SUPER])) {
        this.roles = res.data;
      } else {
        this.roles = res.data.filter(role => role.id !== 1);
      }
    })
  }

  isClientAdmin(){
    if(this.getRoleType() == CONSTANTS.ADMIN_TYPE_CLIENT){
      return true;
    }else{
      return false;
    }
  }

  getRoleType(){
    if(this.adminForm.getRawValue().role){
      var role = this.roles.find(x => x.id == parseInt(this.adminForm.getRawValue().role));
      if(role){
        return role.role;
      }else{
        return null;
      }
    }else{
      return null;
    }
  }


  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  submit() {

    FormUtils.markFormGroupTouched(this.adminForm);

    this.message = null;
    this.error = null;

    if(!this.adminForm.valid){
      return;
    }
  
    // If clientData is provided, ensure clientCompanyId is set
    if(this.clientData && !this.adminForm.getRawValue().clientCompanyId){
      this.adminForm.patchValue({ clientCompanyId: this.clientData.clientId });
    }
    
    // Only validate clientCompanyId if no clientData is provided (backward compatibility)
    if(!this.clientData && this.getRoleType() == CONSTANTS.ADMIN_TYPE_CLIENT && !this.adminForm.getRawValue().clientCompanyId){
      this.error = "Please select the company the client account is assigned to";
      return;
    }

    this.auth.createAdmin(this.adminForm.getRawValue()).then((res: any) => {

      if (res.status) {
        this.message = "Administrator Created";
        this.created = true;
      } else {
        this.error = res.message;
      }

    }).catch(e => {
      this.error = e;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/admin-dashboard/manage-users/create-admin-dialog/create-admin-dialog.component.ts